import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=1be7e43c"
import script from "./social-buttons.js?vue&type=script&lang=js&external"
export * from "./social-buttons.js?vue&type=script&lang=js&external"
import style0 from "./social-buttons.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports